import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faSyncAlt,
    faCheck,
    faCalendarDays,
} from '@fortawesome/free-solid-svg-icons'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'
import { toast } from 'react-toastify'
import RequestQueue from '../../api/requestQueue'
import DatePicker, { DateObject } from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import Toolbar from 'react-multi-date-picker/plugins/toolbar'

import { UnixToDate } from '../../component/unixtodate'
import { Bar, Pie, Line } from 'react-chartjs-2'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js'
import { formatSecondsToTime } from '../../component/formatSecondsToTime'
import { AppContextMenu } from '../../App'

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
)

function Reports() {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('reports')
    }, [])
    const [loading, setLoading] = useState(false)

    const [selectedDateStart, setSelectedDateStart] = useState()
    const [selectedDateEnd, setSelectedDateEnd] = useState()
    const navigate = useNavigate()

    const [reportData, setReportData] = useState(null)

    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])

    const getData = async () => {
        setLoading(true)

        let defaultTimeFrom
        defaultTimeFrom = new DateObject({
            calendar: persian,
            locale: persian_fa,
            format: 'HH:mm',
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            date: selectedDateStart,
        })

        let defaultTimeTo
        defaultTimeTo = new DateObject({
            calendar: persian,
            locale: persian_fa,
            format: 'HH:mm',
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
            date: selectedDateEnd,
        })

        let url = `/furlough-request/reports?from=${UnixToDate(defaultTimeFrom.unix).toISOString()}&to=${UnixToDate(defaultTimeTo.unix).toISOString()}`

        await RequestQueue.sendRequest({
            config: {
                method: 'patch',
                url: url,
            },
            resolve: (res) => {
                setReportData(res.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    return (
        <>
            {loading && <Loading />}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />
                    <div className="box transaction-box w-full">
                        <div className="w-full px-4 py-8">
                            <div className="bg-white w-full rounded-xl shadow-sm  border border-gray-100">
                                {/* Header - Fixed Desktop Style */}
                                <div className="px-6 py-5 border-b rounded-xl border-gray-200 flex maxLg:flex-col justify-between items-center bg-gradient-to-r from-purple-100 to-indigo-500  ">
                                    <h2 className="text-2xl font-semibold text-white">
                                        گزارش کلی
                                    </h2>
                                    <div className="flex">
                                        <button
                                            onClick={getData}
                                            className=" bg-gradient-to-r m-2 to-green-600 from-teal-600 hover:from-teal-700 hover:to-green-700 transition-all shadow-md hover:shadow-lg text-white px-5 py-2.5 rounded-lg  duration-300  transform hover:-translate-y-0.5 flex items-center gap-2"
                                        >
                                            <FontAwesomeIcon
                                                icon={faCheck}
                                                className="ml-2"
                                            />
                                            اعمال فیلتر
                                        </button>
                                    </div>
                                </div>
                                {/* Filters */}
                                <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                از تاریخ
                                            </label>
                                            <div className="relative">
                                                <DatePicker
                                                    inputMode="none"
                                                    calendar={persian}
                                                    locale={persian_fa}
                                                    value={selectedDateStart}
                                                    onChange={
                                                        setSelectedDateStart
                                                    }
                                                    plugins={[
                                                        <Toolbar
                                                            position="bottom"
                                                            sort={[
                                                                'close',
                                                                'today',
                                                                'deselect',
                                                            ]}
                                                        />,
                                                    ]}
                                                    format="YYYY/MM/DD"
                                                    className="w-full  bg-white  rounded-xl "
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        padding: '10px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #ccc',
                                                    }}
                                                />
                                                <FontAwesomeIcon
                                                    icon={faCalendarDays}
                                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                تا تاریخ
                                            </label>
                                            <div className="relative">
                                                <DatePicker
                                                    inputMode="none"
                                                    calendar={persian}
                                                    locale={persian_fa}
                                                    value={selectedDateEnd}
                                                    onChange={
                                                        setSelectedDateEnd
                                                    }
                                                    plugins={[
                                                        <Toolbar
                                                            position="bottom"
                                                            sort={[
                                                                'close',
                                                                'today',
                                                                'deselect',
                                                            ]}
                                                        />,
                                                    ]}
                                                    format="YYYY/MM/DD"
                                                    className="w-full  bg-white  rounded-xl "
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        padding: '10px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #ccc',
                                                    }}
                                                />
                                                <FontAwesomeIcon
                                                    icon={faCalendarDays}
                                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {reportData && (
                                    <div className="container mx-auto p-4 flex flex-col">
                                        <h1 className="text-2xl font-bold mb-6">
                                            گزارشات مرخصی
                                        </h1>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                            <div className="bg-white p-4 rounded-lg shadow">
                                                <h2 className="text-xl font-semibold mb-4">
                                                    آمار کلی
                                                </h2>
                                                <div className="grid grid-cols-2 gap-4">
                                                    <StatCard
                                                        title="کل درخواست‌ها"
                                                        value={
                                                            reportData?.totalRequests
                                                        }
                                                    />
                                                    <StatCard
                                                        title="تایید شده"
                                                        value={
                                                            reportData?.approvedRequests
                                                        }
                                                        color="green"
                                                    />
                                                    <StatCard
                                                        title="رد شده"
                                                        value={
                                                            reportData?.rejectedRequests
                                                        }
                                                        color="red"
                                                    />
                                                    <StatCard
                                                        title="در انتظار"
                                                        value={
                                                            reportData?.pendingRequests
                                                        }
                                                        color="yellow"
                                                    />
                                                    <StatCard
                                                        title="نرخ تایید"
                                                        value={`${reportData?.approvalRate.toFixed(1)}%`}
                                                    />
                                                    <StatCard
                                                        title="مجموع ساعات"
                                                        value={formatSecondsToTime(
                                                            reportData?.totalHours
                                                        )}
                                                    />
                                                </div>
                                            </div>

                                            <div className="bg-white p-4 rounded-lg shadow">
                                                <h2 className="text-xl font-semibold mb-4">
                                                    توزیع نوع مرخصی
                                                </h2>
                                                <Pie
                                                    data={
                                                        reportData?.typeFurloughStats
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 gap-6 mb-6">
                                            <div className="bg-white p-4 rounded-lg shadow">
                                                <h2 className="text-xl font-semibold mb-4">
                                                    تعداد درخواست‌ها بر اساس ماه
                                                </h2>
                                                <Line
                                                    data={{
                                                        labels: reportData?.monthlyData.map(
                                                            (m) => m.name
                                                        ),
                                                        datasets: [
                                                            {
                                                                label: 'تعداد درخواست‌ها',
                                                                data: reportData?.monthlyData.map(
                                                                    (m) =>
                                                                        m.requests
                                                                ),
                                                                borderColor:
                                                                    'rgb(75, 192, 192)',
                                                                tension: 0.1,
                                                            },
                                                        ],
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div className="bg-white p-4 rounded-lg shadow">
                                                <h2 className="text-xl font-semibold mb-4">
                                                    توزیع بر اساس بخش کاری
                                                </h2>
                                                <Bar
                                                    data={
                                                        reportData?.departmentStats
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

const StatCard = ({ title, value, color = 'blue' }) => {
    const colorClasses = {
        blue: 'bg-blue-100 text-blue-800',
        green: 'bg-green-100 text-green-800',
        red: 'bg-red-100 text-red-800',
        yellow: 'bg-yellow-100 text-yellow-800',
    }

    return (
        <div className={`p-4 rounded-lg ${colorClasses[color]}`}>
            <h3 className="font-medium">{title}</h3>
            <p className="text-2xl font-bold">{value}</p>
        </div>
    )
}

export default Reports
